import { Box, Typography } from '@mui/material';

const money = (n) =>
  `$${(Number(n) || 0).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** The invoice number a deduction is backed by, as it reads everywhere: "RD 95". */
export const invoiceRefLabel = (ref) => (ref?.invoice_no != null ? `RD ${ref.invoice_no}` : 'Invoice');

/** Turns an eligible-invoice row from the picker into what the deduction stores. */
export const invoiceRefFrom = (inv) => ({
  invoice_id: inv._id,
  invoice_no: inv.invoiceNo ?? null,
  group_id: inv.groupId || null,
  line_index: inv.lineIndex ?? null,
  unit_no: inv.unitNo || '',
  vendor_name: inv.vendorName || '',
  title: inv.title || '',
  total: Number(inv.total) || 0,
});

/**
 * How a linked invoice shows on a deduction row — in the form, the previews and
 * the printed statement: the RD number, then vendor and amount underneath.
 */
const DeductionInvoiceRef = ({ invoiceRef }) => {
  if (!invoiceRef?.invoice_id) return null;
  const sub = [invoiceRef.vendor_name, money(invoiceRef.total)].filter(Boolean).join(' · ');
  return (
    <Box className="soa-invoice-ref" data-testid="deduction-invoice-ref" sx={{ lineHeight: 1.2 }}>
      <Typography component="div" variant="body2" sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
        {invoiceRefLabel(invoiceRef)}
      </Typography>
      {sub && (
        <Typography component="div" variant="caption" color="text.secondary" title={invoiceRef.title || ''}>
          {sub}
        </Typography>
      )}
    </Box>
  );
};

export default DeductionInvoiceRef;
